import { environmentConfig } from "@src/appV2/environment";
import { isCapacitorPlatform } from "@src/appV2/lib/utils/capacitor/platformUtils";

export const getAppUrl = (): string => {
  if (isCapacitorPlatform()) {
    return environmentConfig.REACT_APP_WEB_APP_URL;
  }

  const { hostname, pathname, origin } = globalThis.location;
  if (hostname.endsWith("cloudfront.net")) {
    const match = /^\/pr-\d+\//.exec(pathname);
    if (match) {
      const strippedPathname = match[0].slice(0, -1);
      return `${origin}${strippedPathname}`;
    }
  }

  return origin;
};
